import * as React from "react";
import classNames from "classnames";

export enum CircleBtnType {
    add,
    remove,
}
export interface ICircleBtn {
    onClick: VoidFunction;
    title?: string;
    type: CircleBtnType;
    cssWrapper?: string;
    disabled?: boolean;
}

export const CircleBtn = (props: ICircleBtn) => {
    return (
        <button
            className={classNames(
                props.type == CircleBtnType.add ? "add-button" : "circle-remove-button",
                props.cssWrapper
            )}
            disabled={props.disabled}
            onClick={() => props.onClick()}
        >
            <span className="icon" aria-hidden="true" />
            <span className="text">{props.title}</span>
        </button>
    );
};
